import { Col, Row } from "react-bootstrap";
// import dummyCarddark from "../../../../../assets/images/dummyCarddark.png";
import cardimage from "../../../../../assets/images/cardimage.png";
import Button from "../../../../common/Button/Button";
import style from "./ApplyCard.module.scss";
import {
  applyCardApplicationAction,
  cardDetailsAction,
  setSelectedCard,
} from "../../../../../features/user/userSlice";
import { useEffect, useState, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ROUTES } from "../../../../../routes";
import {
  isStblCardRestrictedCountry,
  STATUS_CODE,
} from "../../../../../utils/constants";
import Loader from "../../../../common/Loader/Loader";
import KycRejectedModal from "../../../../common/Modals/KycRejectModal/KycRejectModal";
import KycApprovedModal from "../../../../common/Modals/KycApprovedModal/KycApprovedModal";

const ApplyCard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [show, setShow] = useState(false)
  const [searchParams, setSearchParams] = useSearchParams();
  const [showKycModal, setShowKycModal] = useState(false);
  const [kycResult, setKycResult] = useState(null); // { success: boolean }
  const [resolvingRoute, setResolvingRoute] = useState(true);
  const [debitCard, setDebitCard] = useState(null);
  const [creditCard, setCreditCard] = useState(null);
  const [apiFailed, setApiFailed] = useState(false);
  const [denied, setDenied] = useState(false);

  const kycProcessedRef = useRef(false);

  const debitcardlist = [
    { infocard: "Seamless top-up from your wallet in USDT" },
    { infocard: "Accepted globally at all Visa merchants" },
    { infocard: "Real-time balance updates and spending notifications" },
    { infocard: "Customizable spending limits (daily, weekly, monthly)" },
    { infocard: "Secure, fast, and reliable cross-border payments" },
  ];

  const getCardDetails = useCallback(async () => {
    try {
      const res = await dispatch(cardDetailsAction());

      const response = res?.payload || res;

      if (response?.status === 200) {
        setResolvingRoute(false)
        const cards = Array.isArray(response?.data?.data) ? response.data.data : [];

        const debit = cards?.find((c) => c.card_type === "DEBIT" && c.status !== "canceled");
        const credit = cards?.find((c) => c.card_type === "CREDIT" && c.status !== "canceled");

        setDebitCard(debit || null);
        setCreditCard(credit || null);

        setApiFailed(false);

        const appStatus = response?.data?.data?.applicationStatus;
        if (appStatus === "denied") {
          setDenied(true);
        }

        if (debit && credit) {
          navigate(ROUTES.STBL_MONEY);
        }
      } else {
        setApiFailed(false);
      }
    } catch (error) {
      setResolvingRoute(false)
      console.error(error);
      setApiFailed(true);
    }
  }, [dispatch, navigate]);

  const cardDetailsData = async () => {
    try {
      const res = await dispatch(applyCardApplicationAction());
      const response = res?.payload || res;
      const applicationStatus = response?.data?.data?.applicationStatus;
      if (response?.status === STATUS_CODE.successful) {
        if (applicationStatus === "needsVerification") {
          navigate(`${ROUTES.APPLY_CARD_FORM}?step=pending`);
        } else if (applicationStatus === "approved") {
          navigate(`${ROUTES.APPLY_CARD_FORM}?step=cardType`);
        } else if (applicationStatus === "denied") {
          setShow(true);
        } else {
          // Default to kycForm if status is empty, null, or unknown
          navigate(`${ROUTES.APPLY_CARD_FORM}?step=kycForm`);
        }
      } else if (response?.data?.message === "User not found.") {
        navigate(`${ROUTES.APPLY_CARD_FORM}?step=kycForm`);
      }
    } catch (error) {
      console.error("Navigation Error:", error);
    }
  };

  const handleKycRedirectResult = useCallback(async () => {
    if (kycProcessedRef.current) return;
    kycProcessedRef.current = true;

    try {
      setResolvingRoute(true);
      const res = await dispatch(applyCardApplicationAction());
      const response = res?.payload || res;
      const status = response?.data?.data?.applicationStatus;

      if (response?.status === STATUS_CODE.successful) {
        if (status === "approved" || status === "approve") {
          setKycResult({ success: true });
          setShowKycModal(true);
        } else {
          setKycResult({ success: false });
          setShowKycModal(true);
        }
      } else {
        setKycResult({ success: false });
        setShowKycModal(true);
      }
    } catch (error) {
      console.error("KYC Result Error:", error);
      setKycResult({ success: false });
      setShowKycModal(true);
    } finally {
      setResolvingRoute(false);
      // Clear the query parameter to prevent execution on refresh
      const newParams = new URLSearchParams(searchParams);
      newParams.delete("kycStatus");
      setSearchParams(newParams, { replace: true });
    }
  }, [dispatch, searchParams, setSearchParams]);


  const creditCardBtnClicked = async () => {
    localStorage.setItem("cardType", "CREDIT");
    dispatch(
      setSelectedCard(
        creditCard
          ? { card_type: "CREDIT", ...creditCard }
          : { card_type: "CREDIT" }
      )
    );

    if (!creditCard) {
      await cardDetailsData();
    } else {
      navigate(ROUTES.STBL_MONEY);
    }
  };

  const debitCardBtnClicked = async () => {
    localStorage.setItem("cardType", "DEBIT");
    dispatch(
      setSelectedCard(
        debitCard
          ? { card_type: "DEBIT", ...debitCard }
          : { card_type: "DEBIT" }
      )
    );

    if (!debitCard) {
      await cardDetailsData(); // 👈 SAME API CALL
    } else {
      navigate(ROUTES.STBL_MONEY);
    }
  };

  useEffect(() => {
    const kycStatus = searchParams.get("kycStatus");
    if (kycStatus === "pending") {
      handleKycRedirectResult();
    } else {
      getCardDetails();
    }
  }, [searchParams, handleKycRedirectResult, getCardDetails]);

  const userCountry = useSelector(
    (state) => state?.persist?.userInfo?.country
  );

  if (isStblCardRestrictedCountry(userCountry)) {
    return (
      <section className={style.applyCard}>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '60vh',
          textAlign: 'center',
          padding: '20px'
        }}>
          <h3 style={{ color: '#00264d', marginBottom: '15px' }}>Service Unavailable</h3>
          <p style={{ fontSize: '1.6rem', color: '#666', maxWidth: '600px' }}>
            This service is not available in your country or region due to legal and regulatory restrictions.
          </p>
        </div>
      </section>
    );
  }

  return (
    resolvingRoute ? <Loader state={resolvingRoute} /> :
      <>
        <section className={style.applyCard}>
          <Row className="cardrows">
            {/* CREDIT CARD */}
            {/* <Col lg={6} md={6}>
              <div className={style.applyCard_inneCard}>
                <div className={style.applyCard_inneCard_leftText}>
                  <h4 className="big">STBL Money Credit Card</h4>
                  <h5>Credit Powered by Your Gold Smarter, Secure, Transparent</h5>

                  <ul className={style.cardlisting}>
                    {craditcardlist.map((items, index) => (
                      <li key={index}>
                        <p>{items.infocard}</p>
                      </li>
                    ))}
                  </ul>
                  <Button
                    className={style.btn_Size}
                    disabled={denied}
                    onClick={() => {
                      creditCardBtnClicked();
                    }}
                  >
                    {denied
                      ? "Rejected"
                      : apiFailed
                        ? "Apply for Card"
                        : creditCard
                          ? "View Card"
                          : "Apply for Card"}
                  </Button>
                  {denied && (
                    <p className="text-danger mt-2" style={{ fontSize: "1.4rem" }}>
                      Your KYC was rejected. Please try again using a new account.
                    </p>
                  )}
                </div>

                <div className={style.applyCard_inneCard_rightCards}>
                  <div className={style.cardImg}>
                    <img src={dummyCardlight} alt="credit-card" />
                  </div>
                </div>
              </div>
            </Col> */}

            {/* DEBIT CARD */}
            <Col lg={6} md={6}>
              <div className={style.applyCard_inneCard}>
                <div className={style.applyCard_inneCard_leftText}>
                  <h4 className="big">STBL Money Card</h4>
                  <h5>Spend Your USDT Anywhere, Instantly</h5>

                  <ul className={style.cardlisting}>
                    {debitcardlist.map((items, index) => (
                      <li key={index}>
                        <p>{items.infocard}</p>
                      </li>
                    ))}
                  </ul>
                  <Button
                    className={style.btn_Size}
                    disabled={denied}
                    onClick={() => {
                      debitCardBtnClicked();
                    }}
                  >
                    {denied
                      ? "Rejected"
                      : apiFailed
                        ? "Apply for Card"
                        : debitCard
                          ? "View Card"
                          : "Apply for Card"}
                  </Button>
                  {denied && (
                    <p className="text-danger mt-2" style={{ fontSize: "1.4rem" }}>
                      Your KYC was rejected. Please try again using a new account.
                    </p>
                  )}
                </div>

                <div className={style.applyCard_inneCard_rightCards}>
                  <div className={style.cardImg}>
                    <img src={cardimage} alt="debit-card" />
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </section>
        {show &&
          <KycRejectedModal
            show={show}
            handleClose={() => setShow(false)}
          />}
        <KycApprovedModal
          show={showKycModal}
          isSuccess={kycResult?.success}
          onDismiss={() => {
            setShowKycModal(false);
            if (kycResult?.success) {
              navigate(`${ROUTES.APPLY_CARD_FORM}?step=cardType`);
            }
          }}
          onApplyNow={() => {
            setShowKycModal(false);
            navigate(`${ROUTES.APPLY_CARD_FORM}?step=cardType`);
          }}
        />
      </>
  );
};

export default ApplyCard;
